// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --white-color: #fff;
  --white-color-v1: #fcfcfc;
  --black-color: #000;
  --black-color-v1: #3636364a;
  --black-color-v2: #141414;
  --black-color-v3: #2e292a;
  --primary-color: #0f9a08;

  --green-color-v1: #86cc83;

  --body-color: #fcf5e4;
  --bg-light: #f3f3f3;
  --peach-color: #faf3e2;
  --button-hover: #c29c3e;
  --hover-green: #eaffe9;
  --peach-color-v2: #fdeec9;
  --yellow-color: #f5dd36;
  --red-color: #bc0a0e;
  --input-backround: "#fcfcfc";
  --light-red-color: #fceaea;
  --light--green: #b2f8e7;
  --heading-text-color: #434343;
  --border-color-v2: #3636364a;
  --text-color-v1: #363636;
  --text-color-v2: #342f2f;
  --text-color-v3: #595959;
  --text-color-v4: #0d1939;
  --para-text: #686868;

  --text-gray-color: #494b49;
  --border-color: #8e8e8e;

  --border-green: #f7fff6;

  --gray-color-v1: #a1a6b2;
  --box-shadow: #0000000d;
}
`, "",{"version":3,"sources":["webpack://./src/assets/css/color.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,2BAA2B;EAC3B,yBAAyB;EACzB,yBAAyB;EACzB,wBAAwB;;EAExB,yBAAyB;;EAEzB,qBAAqB;EACrB,mBAAmB;EACnB,sBAAsB;EACtB,uBAAuB;EACvB,sBAAsB;EACtB,yBAAyB;EACzB,uBAAuB;EACvB,oBAAoB;EACpB,4BAA4B;EAC5B,0BAA0B;EAC1B,uBAAuB;EACvB,6BAA6B;EAC7B,4BAA4B;EAC5B,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,oBAAoB;;EAEpB,0BAA0B;EAC1B,uBAAuB;;EAEvB,uBAAuB;;EAEvB,wBAAwB;EACxB,uBAAuB;AACzB","sourcesContent":[":root {\n  --white-color: #fff;\n  --white-color-v1: #fcfcfc;\n  --black-color: #000;\n  --black-color-v1: #3636364a;\n  --black-color-v2: #141414;\n  --black-color-v3: #2e292a;\n  --primary-color: #0f9a08;\n\n  --green-color-v1: #86cc83;\n\n  --body-color: #fcf5e4;\n  --bg-light: #f3f3f3;\n  --peach-color: #faf3e2;\n  --button-hover: #c29c3e;\n  --hover-green: #eaffe9;\n  --peach-color-v2: #fdeec9;\n  --yellow-color: #f5dd36;\n  --red-color: #bc0a0e;\n  --input-backround: \"#fcfcfc\";\n  --light-red-color: #fceaea;\n  --light--green: #b2f8e7;\n  --heading-text-color: #434343;\n  --border-color-v2: #3636364a;\n  --text-color-v1: #363636;\n  --text-color-v2: #342f2f;\n  --text-color-v3: #595959;\n  --text-color-v4: #0d1939;\n  --para-text: #686868;\n\n  --text-gray-color: #494b49;\n  --border-color: #8e8e8e;\n\n  --border-green: #f7fff6;\n\n  --gray-color-v1: #a1a6b2;\n  --box-shadow: #0000000d;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
